import { render } from "./Market.vue?vue&type=template&id=75787dde&scoped=true"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"

import "./Market.vue?vue&type=style&index=0&id=75787dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75787dde"]])

export default __exports__